import { render } from "./Blog.vue?vue&type=template&id=2f4d8b47&scoped=true"
import script from "./Blog.vue?vue&type=script&lang=js"
export * from "./Blog.vue?vue&type=script&lang=js"

import "../styles/seo-page.css?vue&type=style&index=0&lang=css&external"
import "./Blog.vue?vue&type=style&index=1&id=2f4d8b47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4d8b47"]])

export default __exports__